"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("@emotion/react");
var _styles = require("./styles");
var _Video = _interopRequireDefault(require("../Video"));
var _Image = _interopRequireDefault(require("../Image"));
var _nukaCarousel = _interopRequireDefault(require("nuka-carousel"));
var _react2 = _interopRequireDefault(require("react"));
var _Text = _interopRequireDefault(require("../Text"));
var _IconChevronLeft = _interopRequireDefault(require("../../icons/General/IconChevronLeft"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MediaCarousel = ({
  media,
  autoPlay = false,
  objectFit = 'contain',
  height = '100%',
  scale = 1.015,
  className,
  radius,
  withShadow,
  altText = 'Karusellbilde'
}) => {
  const theme = (0, _react.useTheme)();
  const hasMultipleImages = Boolean(media?.length > 1);
  const Media = ({
    mediaItem
  }) => {
    const isVideo = Boolean(mediaItem.mimeType?.includes('video'));
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ImageWrapper, {
      height: height,
      scale: scale,
      children: isVideo ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Video.default, {
        src: mediaItem.src,
        autoPlay: autoPlay,
        intersectionObserver: true
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.default, {
        src: mediaItem.src,
        alt: altText,
        objectFit: objectFit
      })
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CarouselWrapper, {
    height: height,
    theme: theme,
    className: className,
    radius: radius,
    withShadow: withShadow,
    "aria-label": "Mediakarusell",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_nukaCarousel.default, {
      enableKeyboardControls: true,
      swiping: hasMultipleImages,
      dragging: hasMultipleImages,
      wrapAround: true,
      cellSpacing: 15,
      renderCenterRightControls: ({
        nextSlide
      }) => hasMultipleImages && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ControlButton, {
        onClick: nextSlide,
        direction: "right",
        "aria-label": "Neste bilde",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconChevronLeft.default, {
          size: 18,
          color: theme.btnDefaultFontColor,
          flip: true
        })
      }),
      renderCenterLeftControls: ({
        previousSlide
      }) => hasMultipleImages && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ControlButton, {
        onClick: previousSlide,
        direction: "left",
        "aria-label": "Forrige bilde",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconChevronLeft.default, {
          size: 18,
          color: theme.btnDefaultFontColor
        })
      }),
      renderBottomCenterControls: ({
        currentSlide
      }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BottomCarouselWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Text.default, {
          color: theme.btnDefaultFontColor,
          size: "14px",
          children: [currentSlide + 1, " / ", media.length]
        })
      }),
      children: media.map((mediaItem, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(Media, {
        mediaItem: mediaItem
      }, index))
    })
  });
};
var _default = exports.default = MediaCarousel;